module.exports = __webpack_public_path__ + "img/pin-1.7e8ddc98.svg";